import React from 'react'
import {toast} from 'react-toastify'
import {useNavigate} from 'react-router'
import {useAuthClient} from '../../utils/use-auth-client'
import {useAsync} from '../../utils/use-async'
import {CouponForm} from './coupon-form'

function NewCouponForm() {
  const {run} = useAsync()
  const client = useAuthClient()
  const navigate = useNavigate()

  const submitForm = async data => {
    try {
      await run(client('coupons/createCoupon', {data}))
      toast.success('Coupon created successfully')
      navigate('/coupons')
    } catch (error) {
      toast.error(error.message)
    }
  }

  return (
    <>
      <h1
        style={{
          fontFamily: "'Inter', 'Helvetica Neue', Arial, sans-serif",
          fontSize: '20px',
          fontWeight: 700,
          color: '#111827',
          margin: '0 0 24px',
        }}
      >
        New Coupon
      </h1>
      <CouponForm submitForm={submitForm} />
    </>
  )
}

export {NewCouponForm}
